import dayjs from 'dayjs';
import { TagProps } from 'front-commons/ds/components/Tag/interfaces';
import { CustomError } from 'shared/errors';
import { simulatedViewType } from 'stores/customer/helpers';

export const getNotificationMessage = (error: unknown) => {
	if (error === 'forbidden' && !!simulatedViewType()) {
		return 'Esse é um usuário simulado. Você não pode realizar essa ação.';
	}

	return error instanceof CustomError
		? error.message
		: 'Não foi possível atualizar a quantidade desse item, tente novamente.';
};


export const getConflictedDialogContent = (description: string) => {
	return {
		heading: {
			title: 'Conflito de produtos',
			showCloseButton: true,
		},
		content: {
			description: `Não foi possível adicionar esse produto ao carrinho, pois o ${description} já foi adicionado anteriormente.`,
		},
		footer: {
			primaryButton: {
				label: 'Entendi',
			},
		},
	}
}

export function getTags(product: Partial<Pick<ProductEntity, 'progressiveDiscount' | 'progressiveDiscountProductMix' | 'limitedByQuantity' | 'endDate' | 'fixedAmount' | "productType">>): TagProps[] {
	const tags: TagProps[] = []

	const isProgressiveDiscount = product.progressiveDiscount || product.progressiveDiscountProductMix

	if (isProgressiveDiscount) {
		tags.push({
			bgColor: product.limitedByQuantity ? '--fuchsia-50' : '--success-surface',
			color: product.limitedByQuantity ? '--fuchsia-800' : '--semantic-success-text',
			label: 'Desconto progressivo',
		})
	}

	if (!isProgressiveDiscount && (product.fixedAmount || (product.productType !== 'SIMPLE' && !tags.length))) {
		tags.push({
			bgColor: product.limitedByQuantity ? '--fuchsia-50' : '--success-surface',
			color: product.limitedByQuantity ? '--fuchsia-800' : '--semantic-success-text',
			label: 'Combo',
		})
	}

	const diffInHours = dayjs(product.endDate).diff(dayjs(), 'hour')
	const pluralSuffix = diffInHours < 2 ? '' : 's'
	const shouldShowEndTag = !!product.endDate && product.productType !== "SIMPLE" && (diffInHours / 24) <= 7

	if (shouldShowEndTag) {
		tags.push({
			bgColor: '--warning-surface',
			color: '--orange-500',
			label: diffInHours > 24
				? `${Math.floor(diffInHours / 24)} dias restantes`
				: `${diffInHours ? diffInHours : 1} hora${pluralSuffix} restante${pluralSuffix}`,
			iconOptions: { name: 'alarm' },
		})
	}

	return tags
}
